<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container">
          <div class="page-links">
            <router-link to='/settings/territory' class="page-links__item">Territory</router-link>
            <router-link to='/settings/location' class="page-links__item">Location</router-link>
            <router-link to='/settings/area' class="page-links__item is-active">Area</router-link>
            <router-link to='/settings/airstrip' class="page-links__item">Airstrip</router-link>
          </div>
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="geo-section geo-section--area" v-if="isLoad">
            <div class="page-title">
              <h2>Setting & Data | Geo | Area</h2>
            </div>
            <div class="geo-section__add">
              <div class="section-title">
                <h3>Add Area</h3>
              </div>
              <form action="javascript:void(0)" class="geo-section__area-form">
                <div class="add-block__container">
                  <div class="form-control-group"><span class="form-control-label">Title</span>
                    <div :class="['form-control-wrap', { 'is-error' : errors.title}]">
                      <input type="text" Placeholder="Title" @focus="errors.title = false" v-model="add.title"
                             class="form-control"/>
                    </div>
                  </div>
                  <div :class="['form-control-group', { 'is-error' : errors.googlePlaceId}]"><span class="form-control-label">Location</span>
                    <div :class="['select-wrapper', {'is-active' : selects.location}]"
                         @click="selects.location = !selects.location; errors.location = false">
                      <div class="select-trigger"><span
                          class="select-trigger__name">{{
                          locations.find(item => item.active) ? locations.find(item => item.active).location.names.EN : 'Choose'
                        }}</span><span
                          class="select-trigger__icon">
                          <svg width="1em" height="1em" class="icon icon-chevron ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                          </svg></span></div>
                      <div class="select-body">
                        <div class="select-inner">
                          <div
                              v-for="item in locations"
                              :key="item.location.id"
                              :class="['select-option', { 'is-selected' : item.active }]"
                              @click="locations = locations.map((locale) => locale.location.id === item.location.id ? {...locale, active: true} : {...locale, active: false})">
                            <span class="select-option__name">{{ item.location.names.EN }}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-control-group"><span class="form-control-label">Place ID</span>
                    <div :class="['form-control-wrap', { 'is-error' : errors.googlePlaceId}]">
                      <input type="text" Placeholder="Place ID" @focus="errors.googlePlaceId = false" v-model="add.googlePlaceId"
                             class="form-control"/>
                    </div>
                  </div>
                </div>

                <button type="submit" class="btn btn--green geo-section__location-form__submit" @click="addAreaHandler">
                  <span>Add</span></button>
              </form>
            </div>
            <div class="geo-section__area">
              <div class="section-title">
                <h3>Areas</h3>
                <div class="form-control-wrap">
                  <input type="text" placeholder="Search" v-model="search" class="form-control-search"/>
                  <div class="form-control-icon">
                    <svg width="1em" height="1em" class="icon icon-search ">
                      <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <div data-simplebar="data-simplebar" class="section-table-wrap">
                <div class="section-table section-table--geo">
                  <div class="section-table__head">
                    <div class="col col-area"><span>Area</span></div>
                    <div class="col col-location"><span>Location</span></div>
                    <div class="col col-added"><span>Added</span></div>
                    <div class="col col-edited"><span>Edited</span></div>
                  </div>
                  <div class="section-table__body">
                    <div class="section-table__row"
                         v-for="(item, index) in areas.slice((page - 1) * 15, ((page - 1) * 15) + 15)"
                         :key="item.area.id">
                      <div class="col col-area">
                        <div class="section-table__row__number">{{ index + 1 }}</div>
                        <div class="section-table__row__name">{{ item.area.names.EN }}</div>
                      </div>
                      <div class="col col-location"><span>{{ item.location.names.EN }}</span></div>
                      <div class="col col-added"><span>{{ item.area.createdAt }}</span></div>
                      <div class="col col-edited"><span>{{ item.area.updatedAt }}</span></div>
                      <div class="col col-actions">
                        <button type="button" class="btn btn--edit" @click="editArea(item.area.id)">
                          <svg width="1em" height="1em" class="icon icon-edit ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                          </svg>
                        </button>
                        <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                    entity: 'Area',
                                    name: item.area.title,
                                    handler: deleteAreaHandler,
                                    id: item.area.id
                                })">
                          <svg width="1em" height="1em" class="icon icon-close ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Pagination
                  :page="page"
                  :pageCount="pageCount"
                  @pageController="pageController"
              />
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="edit">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--area">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon" :style="{minWidth: '21px'}">
                <svg width="1em" height="1em" class="icon icon-edit ">
                  <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use>
                </svg>
              </div>
              <span :style="{whiteSpace: 'nowrap'}">Edit Area</span>
            </div>
            <div class="form-control-group form-control-group-lang-horiz"
                 :style="{justifyContent: 'flex-end', marginRight: '2rem'}"><span
                class="form-control-label">Language:</span>
              <div :class="['select-wrapper select-wrapper__lang', { 'is-active' : selects.langEdit } ]"
                   @click="changeSelects('langEdit')" :style="{width: '16rem'}">
                <div class="select-trigger">
                  <div class="select-trigger__flag__icon">
                    <svg width="1em" height="1em" class="icon icon-rus"
                         :style="langEdit === 'DE' || langEdit === 'ES' ? {width: '18px', height: '18px', marginBottom: '1px'} : {}">
                      <use :xlink:href="getLanguageIcon(langEdit)"></use>
                    </svg>
                  </div>
                  <span
                      class="select-trigger__name">{{ getLanguageTitle(langEdit) }}</span><span
                    class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg></span>
                </div>
                <div class="select-body">
                  <div class="select-inner js-scrollbar">
                    <div class="select-option" @click="langEdit = 'RU'"><span class="select-option__name">
                                <div class="select-trigger__flag__icon">
                                  <svg width="1em" height="1em" class="icon icon-ru">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-ru"></use>
                                  </svg>
                                </div>Russian
                              </span></div>
                    <div class="select-option" @click="langEdit = 'EN'"><span class="select-option__name">
                                <div class="select-trigger__flag__icon">
                                  <svg width="1em" height="1em" class="icon icon-usa">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-usa"></use>
                                  </svg>
                                </div>English
                              </span>
                    </div>
                    <div class="select-option" @click="langEdit = 'DE'"><span class="select-option__name">
                                <div class="select-trigger__flag__icon">
                                  <svg width="1em" height="1em" class="icon icon-rus"
                                       :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                                  </svg>
                                </div>Deutch
                              </span></div>
                    <div class="select-option" @click="langEdit = 'ES'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-rus"
                               :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-es"></use>
                          </svg>
                        </div>
                        Spanish
                      </span>
                    </div>
                    <div class="select-option" @click="langEdit = 'FR'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-rus"
                               :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fr"></use>
                          </svg>
                        </div>
                        French
                      </span>
                    </div>
                    <div class="select-option" @click="langEdit = 'PT'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-rus"
                               :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-pt"></use>
                          </svg>
                        </div>
                        Portuguese
                      </span>
                    </div>
                    <div class="select-option" @click="langEdit = 'NL'">
                      <span class="select-option__name">
                        <div class="select-trigger__flag__icon">
                          <svg width="1em" height="1em" class="icon icon-rus"
                               :style="{width: '18px', height: '18px', marginBottom: '1px'}">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-nl"></use>
                          </svg>
                        </div>
                        Dutch
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__close" @click="isEdit ? $emit('notLeavePopupHandler', {
                            handler: clearEdit
                        }) : edit = null">
              <svg width="1em" height="1em" class="icon icon-close ">
                <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__side">
              <div class="form-control-group"><span class="form-control-label">Title</span>
                <div :class="['form-control-wrap', { 'is-error' : errorsEdit.title}]">
                  <input type="text" Placeholder="Title" @change="isEdit = true" v-model="edit.names[langEdit]"
                         @focus="errorsEdit.title = false" class="form-control">
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div :class="['form-control-group', { 'is-error' : errorsEdit.location}]"><span
                  class="form-control-label">Location</span>
                <div :class="['select-wrapper', {'is-active' : selects.locationEdit}]"
                     @click="selects.locationEdit = !selects.locationEdit;errorsEdit.location = false">
                  <div class="select-trigger"><span
                      class="select-trigger__name">{{
                      locationsEdit.find(item => item.active) ? (locationsEdit.find(item => item.active).location.names[langEdit] || locationsEdit.find(item => item.active).location.names['EN']) : 'Choose'
                    }}</span><span
                      class="select-trigger__icon">
							<svg width="1em" height="1em" class="icon icon-chevron ">
								<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
							</svg></span></div>
                  <div class="select-body">
                    <div class="select-inner">
                      <div
                          v-for="item in locationsEdit"
                          :key="item.location.id"
                          :class="['select-option', { 'is-selected' : item.active }]"
                          @click="locationsEdit = locationsEdit.map((locale) => locale.location.id === item.location.id ? {...locale, active: true} : {...locale, active: false});isEdit = true">
                        <span class="select-option__name">{{ item.location.names[langEdit] || item.location.names['EN'] }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="edit-popup__side">
              <div class="form-control-group"><span class="form-control-label">Place ID</span>
                <div :class="['form-control-wrap', { 'is-error' : errorsEdit.googlePlaceId}]">
                  <input type="text" Placeholder="Place ID" @change="isEdit = true" v-model="edit.googlePlaceId"
                         @focus="errorsEdit.googlePlaceId = false" class="form-control">
                </div>
              </div>
            </div>
            <button type="submit" class="btn btn--green edit-popup__submit" @click="updateAreaHandler"><span>Save</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {getAreasAll, getLocationsAll, createArea, deleteArea, getArea, updateArea} from '@/utilites/api'

import Pagination from '@/components/Pagination'
import { getLanguageIcon, getLanguageTitle } from '../../common/helpers/language'

export default {
  props: ['user'],
  components: {Pagination},
  data() {
    return {
      areasData: [],
      locations: [],
      locationsEdit: [],
      areas: [],
      add: {
        title: '',
        googlePlaceId: null,
      },
      // selects: {
      //   location: false,
      //   locationEdit: false,
      // },
      selects: {
        territory: false,
        location: false,
        areas: false,
        territoryEdit: false,
        locationEdit: false,
        areasEdit: false,
        langEdit: false
      },
      langEdit: 'EN',
      page: 1,
      pageCount: 0,
      search: '',
      edit: null,
      isLoad: false,
      isEdit: false,
      errors: {
        title: false,
        location: false
      },
      errorsEdit: {
        title: false,
        location: false
      },
    }
  },
  beforeCreate() {
    document.title = 'Setting & Data / Geo / Area'
  },
  mounted() {
    document.title = 'Setting & Data / Geo / Area'
    this.updateData()
    getLocationsAll(this.user.access_token)
        .then(res => {
          this.locations = res.map((item, index) => ({...item, active: false}))
          this.locationsEdit = res.map((item, index) => ({...item, active: false}))
        })

    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          location: false,
          locationEdit: false
        }
      }
      if (!event.target.closest('.edit-popup') && !event.target.closest('.btn')) {
        if (this.isEdit) {
          this.$emit('notLeavePopupHandler', {
            handler: this.clearEdit
          })
        } else {
          this.edit = false
        }
      }
    })
  },
  methods: {
    getLanguageTitle,
    getLanguageIcon,
    changeSelects(target) {
      this.selects = {
        territory: false,
        location: false,
        areas: false,
        territoryEdit: false,
        locationEdit: false,
        areasEdit: false,
        langEdit: false,
        [target]: !this.selects[target]
      }
    },
    checkErrors() {
      this.errors = {
        title: /[^A-Za-z0-9\- ]/g.test(this.add.title.trim()) || this.add.title.trim().length === 0,
        location: !this.locations.find(item => item.active),
      }
      let error = false
      for (const key in this.errors) {
        if (this.errors[key]) {
          error = true
        }
      }
      return error
    },
    checkErrorsEdit() {
      this.errorsEdit = {
        title: /[^A-Za-z0-9\- ]/g.test(this.edit.names.EN.trim()) || this.edit.names.EN.trim().length === 0,
        location: !this.locationsEdit.find(item => item.active),
      }
      let error = false
      for (const key in this.errorsEdit) {
        if (this.errorsEdit[key]) {
          error = true
        }
      }
      return error
    },
    pageController(page) {
      this.page = page
    },
    pageCountHandler() {
      this.pageCount = Math.ceil(this.areas.length / 15)
    },
    addAreaHandler() {
      if (!this.checkErrors()) {
        createArea(this.user.access_token, {
          names: {
            EN: this.add.title,
            RU: this.add.title,
            DE: this.add.title,
            ES: this.add.title,
            FR: this.add.title,
            PT: this.add.title,
            NL: this.add.title,
          },
          location: this.locations.find(item => item.active).location.id,
          googlePlaceId: this.add.googlePlaceId,
        })
            .then(() => {
              this.updateData()
              this.add = {
                title: '',
                googlePlaceId: null,
              }
              this.locations = this.locations.map(item => ({...item, active: false}))
              this.$emit('confirmed')
            })
      }
    },
    editArea(id) {
      this.errorsEdit = {
        title: false,
        location: false
      }
      getArea(this.user.access_token, id)
          .then(res => {
            this.edit = res
            this.locationsEdit = this.locationsEdit.map(item => ({
              ...item,
              active: this.areas.find(ar => ar.area.id === id).location.id === item.location.id
            }))
          })
    },
    updateAreaHandler() {
      if (!this.checkErrorsEdit()) {
        updateArea(this.user.access_token, {
          id: this.edit.id,
          names: this.edit.names,
          location: this.locationsEdit.find(item => item.active).location.id,
          googlePlaceId: this.edit.googlePlaceId,
        })
            .then(res => {
              this.updateData()
              this.edit = null
              this.$emit('confirmed')
              this.isEdit = false
            })
      }
    },
    deleteAreaHandler(id) {
      deleteArea(this.user.access_token, id)
          .then(() => {
            this.updateData()
            this.$emit('confirmed')
          })
          .catch(() => this.$emit('errored', 'You cannot delete Area, if they have bound fields "Airstrip"'))
    },
    updateData() {
      this.isLoad = false
      getAreasAll(this.user.access_token)
          .then(res => {
            this.isLoad = true
            this.areas = res.map((item, index) => index === 0 ? {...item, active: true} : {...item, active: false})
            this.areasData = res.map((item, index) => index === 0 ? {...item, active: true} : {...item, active: false})
          })
    },
    clearEdit() {
      this.edit = null
      this.isEdit = false
    }
  },
  watch: {
    areas() {
      this.pageCountHandler()
    },
    search() {
      if (this.search.length === 0) {
        this.areas = this.areasData
      }
      this.page = 1
      let filtered = this.areasData.filter(item => this.search.length ? (item.area.names.EN && item.area.names.EN.toLowerCase().includes(this.search.toLowerCase())) ? item : false : item)
      this.areas = filtered
      this.pageCount = Math.ceil(filtered.length / 15)
    }
  }
}
</script>
<style scoped lang="scss">
.add-block__container {
  display: flex;
  margin: 10px 0;
  width: 100%;
}
</style>